export function directoryFilter() {
  addEventListener("change", (ev) => {
    const input = ev.target;
    if (!input.matches(".filter-tag input")) return;

    const tag = input.value;
    const tools = input.closest(".directory-grid__tools");
    const listContainer = tools?.nextElementSibling;
    if (!listContainer) return;
    listContainer.dataset.activeFilter = tag;
    updateVisibility(listContainer);
  });
}

export function directorySearch() {
  let debounceTimer;

  addEventListener("input", (ev) => {
    if (!ev.target.classList.contains("search__input")) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const query = ev.target.value.trim().toLowerCase();
      const tools = ev.target.closest(".directory-grid__tools");
      const listContainer = tools?.nextElementSibling;
      if (!listContainer) return;

      // Store the active search query on the container so filter can read it
      listContainer.dataset.activeSearch = query;

      updateVisibility(listContainer);
    }, 500);
  });
}

function updateVisibility(listContainer) {
  const tag = (listContainer.dataset.activeFilter || "all").toLowerCase();
  const query = (listContainer.dataset.activeSearch || "").toLowerCase();

  const items = listContainer.querySelectorAll(".pill");

  items.forEach((item) => {
    const itemTags = item.dataset.tag
      ? item.dataset.tag
          .toLowerCase()
          .split(",")
          .map((t) => t.trim())
      : [];
    const text = item.textContent.toLowerCase();

    const matchesFilter = tag === "all" || itemTags.includes(tag);
    const matchesSearch = text.includes(query);

    const visible = matchesFilter && matchesSearch;
    item.classList.toggle("pill--hidden", !visible);
  });
}
